<template>
  <div class="order-details">
    <div class="title_nav">
      <div @click="$router.go(-1)">
        <Icon name="arrow-left" style="margin-top:0.1rem" />
      </div>
      <div style="padding-top:0.05rem" class="nav_address" v-if="refundOrder">售后详情</div>
      <div style="padding-top:0.05rem" class="nav_address" v-else>订单详情</div>
    </div>
    <template v-if="!refundOrder">
      <div class="nav">
        <div class="navCon acea-row row-between-wrapper">
          <div :class="{ on: status.type === 0 || status.type === 9 }">
            待付款
          </div>
          <div :class="{ on: status.type === 1 }" v-if="orderInfo.shipping_type === 2">
            待核销
          </div>
          <div :class="{ on: status.type === 1 }" v-else>待发货</div>
          <div :class="{ on: status.type === 2 }" v-if="orderInfo.shipping_type === 1">
            待收货
          </div>
          <div :class="{ on: status.type === 3 }">待评价</div>
          <div :class="{ on: status.type === 4 }">已完成</div>
        </div>
        <div class="progress acea-row row-between-wrapper">
          <div class="iconfont" :class="[
            status.type === 0 || status.type === 9
              ? 'icon-webicon318'
              : 'icon-yuandianxiao',
            status.type >= 0 ? 'font-color-red' : ''
          ]"></div>
          <div class="line" :class="{ 'bg-color-red': status.type > 0 && status.type != 9 }"></div>
          <div class="iconfont" :class="[
            status.type === 1 ? 'icon-webicon318' : 'icon-yuandianxiao',
            status.type >= 1 && status.type != 6 && status.type != 9
              ? 'font-color-red'
              : ''
          ]"></div>
          <div class="line" :class="{
            'bg-color-red':
              status.type > 1 && status.type != 6 && status.type != 9
          }" v-if="orderInfo.shipping_type === 1"></div>
          <div class="iconfont" :class="[
            status.type === 2 ? 'icon-webicon318' : 'icon-yuandianxiao',
            status.type >= 2 && status.type != 6 && status.type != 9
              ? 'font-color-red'
              : ''
          ]" v-if="orderInfo.shipping_type === 1"></div>
          <div class="line" :class="{
            'bg-color-red':
              status.type > 2 && status.type != 6 && status.type != 9
          }"></div>
          <div class="iconfont" :class="[
            status.type === 3 ? 'icon-webicon318' : 'icon-yuandianxiao',
            status.type >= 3 && status.type != 6 && status.type != 9
              ? 'font-color-red'
              : ''
          ]"></div>
          <div class="line" :class="{
            'bg-color-red':
              status.type > 3 && status.type != 6 && status.type != 9
          }"></div>
          <div class="iconfont" :class="[
            status.type == 4 ? 'icon-webicon318' : 'icon-yuandianxiao',
            status.type >= 4 && status.type != 6 && status.type != 9
              ? 'font-color-red'
              : ''
          ]"></div>
        </div>
      </div>
      <div class="writeOff" v-if="orderInfo.shipping_type === 2 && orderInfo.paid === 1">
        <div class="title">核销信息</div>
        <div class="grayBg">
          <div class="pictrue"><img :src="orderInfo.code" /></div>
        </div>
        <div class="gear"><img src="@assets/images/writeOff.jpg" /></div>
        <div class="num">{{ orderInfo._verify_code }}</div>
        <div class="rules">
          <div class="item">
            <div class="rulesTitle acea-row row-middle">
              <span class="iconfont icon-shijian"></span>核销时间
            </div>
            <div class="info">
              每日：<span class="time">{{ system_store.day_time }}</span>
            </div>
          </div>
          <div class="item">
            <div class="rulesTitle acea-row row-middle">
              <span class="iconfont icon-shuoming1"></span>使用说明
            </div>
            <div class="info">可将二维码出示给店员扫描或提供数字核销码</div>
          </div>
        </div>
      </div>
      <div class="map acea-row row-between-wrapper" v-if="orderInfo.shipping_type === 2 && orderInfo.paid === 1">
        <div>自提地址信息</div>
        <div class="place cart-color acea-row row-center-wrapper" @click="showChang">
          <span class="iconfont icon-weizhi"></span>查看位置
        </div>
      </div>
      
      <div class="refundlist" v-if="orderInfo.chargeAccount || orderInfo.goodsId !=0 && orderInfo.goodsId !='' && orderInfo.goodsId!=null">
        <div class="Recharge_phone"> 充值账号 ：<span>{{ orderInfo.chargeAccount }}</span></div>
      </div>

      <div class="refundlist" v-else>
        <div class="address" v-if="orderInfo.shipping_type === 1">
          <div class="name">
            <Icon name="location-o" />
            {{ orderInfo.real_name
            }}<span class="phone">{{ orderInfo.user_phone }}</span>
          </div>
          <div style="padding-left: 0.45rem;">{{ orderInfo.user_address }}</div>
        </div>
      </div>

      <div class="refundlist refundlist2">
        <div class="address" v-if="orderInfo.shipping_type === 1">
          <div class="name">
            <Icon name="logistics" />
           {{ orderInfo._status._msg }}
          </div>
          <div style="padding-left:0.45rem">{{ orderInfo.add_time_y }}-{{ orderInfo.add_time_h }}</div>
        </div>

        <div class="icon" v-if="type4logistics" @click="
          $router.push({ path: '/order/logistics/' + orderInfo.order_id })
        ">
          <Icon class="arrow" name="arrow" style="font-size: 0.33rem;"/>
        </div>
      </div>

    </template>
    <!-- 退货流程进度条 -->
    <div class="refundlist" v-if="refundOrder">
      <div class="progressText">{{ orderInfo._status._msg }}</div>
      <div class="progressTime">申请时间： {{ orderInfo.add_time_y }}
        <span class="time">{{ orderInfo.add_time_h }}</span>
      </div>
      <Steps :active="actives" active-color="red" style="width: 90%; margin-left: 0.3rem;">
        <Step>提交申请</Step>
        <Step>商家处理</Step>
        <Step>退款成功</Step>
      </Steps>
    </div>
    <!-- 演出票务信息展示 -->
<div class="refundlist" v-if="orderInfo.code">
  <div class="code">
       <img v-if="orderInfo.code" :src="orderInfo.qrcode_url"  alt='二维码'/>
       <div v-if="orderInfo.code" class="ma">电子码 ：<span>{{orderInfo.code || '请稍后正在出票中...'}}</span></div>
       <div v-if="orderInfo.code" class="ma">使用说明：<span>{{ orderInfo.remark }}</span></div>
    </div>
</div>

    <div class="refundlist" v-if="refundOrder">
      <div class="RefundInformation">退款信息</div>
      <div class="refundTime">退款时间：<span style="color: #a7a7a7;">{{ orderInfo.refund_reason_time }}</span></div>
      <div class="refundTime">退款方式：<span style="color:#a7a7a7;">返回原支付账户</span></div>
    </div>

    <!-- 新商品信息 -->
    <div class="refundlist">
      <div class="quantity" v-if="refundOrder">退款商品</div>
      <div class="quantity" v-else>共{{ orderInfo.total_num }}件商品</div>

      <div class="borderInde" v-for="item in orderInfo.cartInfo" :key="item.id">
        <div class="quantit">
          <div>
            <img :src="item.productInfo.image" alt="" />
          </div>
          <div class="quantiy">
            <div class="quantiyText">{{ item.productInfo.store_name }}</div>
            <div class="quan">
              <div class="tity">
                <div><img src="@/assets/images/icon-money.png" alt=""></div>
              <div>{{ item.productInfo.price }}</div>
              </div>
              <div style="margin-right: 0.2rem !important;">
                x{{ item.cart_num }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 新订单信息 -->
    <div class="orderInformation" v-if="!refundOrder">
      <div style="padding-left: 0.3rem;">
        <div class="titleText" style="padding-top: 0.2rem;">
          订单编号 &nbsp; &nbsp; <span>{{ orderInfo.order_id }}</span> &nbsp;
          <img class="copy-data" :data-clipboard-text="orderInfo.order_id" src="@/assets/images/order_copy.png" />
        </div>
        <div class="titleText">
          下单时间 &nbsp; &nbsp;
          <span>{{ orderInfo.add_time_y }} &nbsp;<span>{{ orderInfo.add_time_h }}</span></span>
        </div>
        <div class="titleText">
          订单状态 &nbsp; &nbsp;
          <span>{{ orderTypeName }}</span>
        </div>
        <div class="titleText">
          支付状态 &nbsp; &nbsp;
          <span>{{ orderInfo.paid ? "已支付" : "未支付" }}</span>
        </div>
        <div class="titleText">
          支付方式 &nbsp; &nbsp;
          <span>{{ orderInfo._status._payType }}</span>
        </div>
      </div>
    </div>
    <div v-if="orderInfo.status != 0">


      <div class="wrapper" v-if="orderInfo.delivery_type === 'send'">
        <div class="item acea-row row-between">
          <div>配送方式：</div>
          <div class="conter">
            送货
          </div>
        </div>
        <div class="item acea-row row-between">
          <div>配送人：</div>
          <div class="conter">{{ orderInfo.delivery_name || "" }}</div>
        </div>
        <div class="item acea-row row-between">
          <div>配送电话：</div>
          <div class="conter acea-row row-middle row-right">
            {{ orderInfo.delivery_id || ""
            }}<a :href="'tel:' + orderInfo.delivery_id"><span class="copy">拨打</span></a>
          </div>
        </div>
      </div>
    </div>
   
    <div style="height:1.2rem;" v-if="!refundOrder && offlineStatus"></div>
    <div class="footer acea-row row-right row-middle" v-if="!refundOrder && offlineStatus">
      <template v-if="status.type === 0">
        <div class="bnt cancel" @click="cancelOrder">取消订单</div>
        <div class="bnt bg-color-red" @click="pay = true">立即付款</div>
      </template>
      <template v-if="status.type === 1">
        <div v-if=" !orderInfo.chargeAccount && orderInfo.goodsId ==0 || orderInfo.goodsId=='' || orderInfo.goodsId ==null" class="bnt cancel" @click="$router.push({ path: '/order/refund/' + orderInfo.order_id })">
          申请退款
        </div>
      </template>
      <template v-if="status.type === 2">
        <div v-if="orderInfo.paid === 1 && orderInfo.refund_status === 0 && !orderInfo.chargeAccount && orderInfo.goodsId ==0 || orderInfo.goodsId=='' || orderInfo.goodsId ==null" class="bnt cancel"
          @click="$router.push({ path: '/order/refund/' + orderInfo.order_id })">
          申请退款
        </div>
        <div class="bnt default" v-if="orderInfo.delivery_type === 'express' && orderInfo.is_stores <= 1" @click="
          $router.push({ path: '/order/logistics/' + orderInfo.order_id })
        ">
          查看物流
        </div>
        <div class="bnt bg-color-red" @click="takeOrder">
          确认收货
        </div>
      </template>
      <template v-if="status.type === 3">
        <div v-if="orderInfo.paid === 1 && orderInfo.refund_status === 0" class="bnt cancel"
          @click="$router.push({ path: '/order/refund/' + orderInfo.order_id })">
          申请退款
        </div>
        <div v-if="orderInfo.delivery_type === 'express' && orderInfo.is_stores <= 1 " class="bnt default" @click="
          $router.push({ path: '/order/logistics/' + orderInfo.order_id })
        ">
          查看物流
        </div>
      </template>
      <template v-if="status.type === 4">
        <div v-if="orderInfo.paid === 1 && orderInfo.refund_status === 0 " class="bnt cancel"
          @click="$router.push({ path: '/order/refund/' + orderInfo.order_id })">
          申请退款
        </div>
        <div class="bnt cancel" @click="delOrder">
          删除订单
        </div>
        <div v-if="orderInfo.delivery_type === 'express' && orderInfo.is_stores <= 1 && type4logistics" class="bnt default" @click="
          $router.push({ path: '/order/logistics/' + orderInfo.order_id })
        ">
          查看物流
        </div>
      </template>
      <!-- <template v-if="status.type === 6">
        <div v-if="orderInfo.paid === 1 && orderInfo.refund_status === 0" class="bnt cancel"
          @click="$router.push({ path: '/order/refund/' + orderInfo.order_id })">
          申请退款
        </div>
        <div class="bnt bg-color-red" @click="
          $router.push({ path: '/activity/group_rule/' + orderInfo.pink_id })
        ">
          查看拼团
        </div>
      </template> -->
      <!-- <div class="bnt bg-color-red" @click="goOrderConfirm(orderInfo)" v-if="
        orderInfo.paid === 1 &&
        orderInfo.refund_status === 0 &&
        orderInfo.status >= 2 
      ">
        再次购买
      </div> -->
    </div>
    <Payment v-model="pay" :types="payType" @checked="toPay" :balance="userInfo.now_money"></Payment>
    <div class="geoPage" v-if="mapShow">
      <iframe frame width="100%" height="100%" frameborder="0" scrolling="no" :src="
        'https://apis.map.qq.com/uri/v1/geocoder?coord=' +
        system_store.latitude +
        ',' +
        system_store.longitude +
        '&referer=' +
        mapKey
      ">
      </iframe>
    </div>
    <GeneralWindow :generalActive="generalActive" @closeGeneralWindow="closeGeneralWindow"
      :generalContent="generalContent"></GeneralWindow>
</div>
</template>
<style scoped>
.goodCall {
  color: #e93323;
  text-align: center;
  width: 100%;
  height: 0.86rem;
  padding: 0 0.3rem;
  border-bottom: 0.01rem solid #eee;
  font-size: 0.3rem;
  line-height: 0.86rem;
  background: #fff;
}
.iconfont {
  margin-right: 0.15rem;
}
.geoPage {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 10000;
}
.order-details .writeOff {
  background-color: #fff;
  margin-top: 0.13rem;
  padding-bottom: 0.3rem;
}
.order-details .writeOff .title {
  font-size: 0.3rem;
  color: #282828;
  height: 0.87rem;
  border-bottom: 1px solid #f0f0f0;
  padding: 0 0.3rem;
  line-height: 0.87rem;
}
.order-details .writeOff .grayBg {
  background-color: #f2f5f7;
  width: 5.9rem;
  height: 3.84rem;
  border-radius: 0.2rem 0.2rem 0 0;
  margin: 0.5rem auto 0 auto;
  padding-top: 0.55rem;
}
.order-details .writeOff .grayBg .pictrue {
  width: 2.9rem;
  height: 2.9rem;
  margin: 0 auto;
}
.order-details .writeOff .grayBg .pictrue img {
  width: 100%;
  height: 100%;
  display: block;
}
.order-details .writeOff .gear {
  width: 5.9rem;
  height: 0.3rem;
  margin: 0 auto;
}
.order-details .writeOff .gear img {
  width: 100%;
  height: 100%;
  display: block;
}
.order-details .writeOff .num {
  background-color: #f0c34c;
  width: 5.9rem;
  height: 0.84rem;
  color: #282828;
  font-size: 0.48rem;
  margin: 0 auto;
  border-radius: 0 0 0.2rem 0.2rem;
  text-align: center;
  padding-top: 0.04rem;
}
.order-details .writeOff .rules {
  margin: 0.46rem 0.3rem 0 0.3rem;
  border-top: 0.01rem solid #f0f0f0;
  padding-top: 0.1rem;
}
.order-details .writeOff .rules .item {
  margin-top: 0.15rem;
}
.order-details .writeOff .rules .item .rulesTitle {
  font-size: 0.28rem;
  color: #282828;
}
.order-details .writeOff .rules .item .rulesTitle .iconfont {
  font-size: 0.3rem;
  color: #333;
  margin-right: 0.08rem;
  margin-top: 0.05rem;
}
.order-details .writeOff .rules .item .info {
  font-size: 0.28rem;
  color: #999;
  margin-top: 0.05rem;
}
.order-details .writeOff .rules .item .info .time {
  margin-left: 0.2rem;
}
.order-details .map {
  height: 0.86rem;
  font-size: 0.3rem;
  color: #282828;
  line-height: 0.86rem;
  border-bottom: 0.01rem solid #f0f0f0;
  margin-top: 0.13rem;
  background-color: #fff;
  padding: 0 0.3rem;
}
.order-details .map .place {
  font-size: 0.26rem;
  width: 1.76rem;
  height: 0.5rem;
  border-radius: 0.25rem;
  line-height: 0.5rem;
  text-align: center;
}
.order-details .map .place .iconfont {
  font-size: 0.27rem;
  height: 0.27rem;
  line-height: 0.27rem;
  margin: 0.02rem 0.03rem 0 0;
}
.order-details .address .name .iconfont {
  font-size: 0.34rem;
  margin-left: 0.1rem;
}
.code {
  width: 80%;
  min-height: 1rem;
  /* background: #f5f5f5; */
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
  padding: .3rem 0;
}
.code img{
width: 2.5rem;
height: 2.5rem;
}
.ma {
  width: 100%;
  margin-bottom: .1rem;
text-align: center;
/* padding-right: .5rem; */
}
</style>

<script>
import OrderGoods from "@components/OrderGoods";
import { orderDetail, orderAgain } from "@api/order";
import ClipboardJS from "clipboard";
import Payment from "@components/Payment";
import { isWeixin } from "@utils";
import { mapGetters } from "vuex";
import {
  cancelOrderHandle,
  takeOrderHandle,
  delOrderHandle,
  payOrderHandle
} from "@libs/order";
import { wechatEvevt } from "@libs/wechat";
import GeneralWindow from "@components/GeneralWindow";
import { Icon, Step, Steps } from "vant";
const NAME = "OrderDetails";
export default {
  name: NAME,
  components: {
    OrderGoods,
    Payment,
    GeneralWindow,
    Icon, Step, Steps
  },
  props: {},
  data: function () {
    return {
      offlinePayStatus: 2,
      orderTypeName: "普通订单",
      orderTypeNameStatus: true,
      offlineStatus: true,
      id: this.$route.params.id,
      orderInfo: {
        _status: {}
      },
      active: 0,
      status: {},
      pay: false,
      payType: ["yue", "weixin", 'zh'],
      from: isWeixin() ? "weixin" : "weixinh5",
      system_store: {},
      mapKay: "",
      mapShow: false,
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: ""
      },
      type4logistics:true,
      CompletedType: parseInt(localStorage.getItem('completed')),
    };
  },
  computed: {
    refundOrder() {
      return this.orderInfo.refund_status > 0;
    },
    ...mapGetters(["userInfo"]),
    //退货进度条
    actives() {
      if (this.orderInfo._status._type == 0) {
        this.active = 0
      } else if (this.orderInfo._status._type == -1) {
        this.active = 1
      } else {
        this.active = 2
      }
      return this.active
    }
  },

  watch: {
    $route(n) {
      if (n.name === NAME && this.id !== n.params.id) {
        this.id = n.params.id;
        this.getDetail();
      }
    }
  },
  inject: ["app"],
  mounted: function () {
    this.getDetail();
    this.$nextTick(function () {
      let copybtn = document.getElementsByClassName("copy-data");
      this.copyFn(copybtn);
    });
  },
  methods: {
    copyFn: function (id) {
      const clipboard = new ClipboardJS(id);
      clipboard.on("success", () => {
        this.$dialog.success("复制成功");
        clipboard.destroy();
      });
    },
    // 再次购买
    goOrderConfirm(e) {
      orderAgain(e.order_id)
        .then(res => {
          this.$router.push({
            path: "/order/submit/" + res.data.cateId
          });
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    },
    closeGeneralWindow(msg) {
      this.generalActive = msg;
      this.getDetail();
    },
    showChang: function () {
      if (isWeixin()) {
        let config = {
          latitude: parseFloat(this.system_store.latitude),
          longitude: parseFloat(this.system_store.longitude),
          name: this.system_store.name,
          address: this.system_store._detailed_address
        };
        wechatEvevt("openLocation", config)
          .then(res => {
            console.log(res);
          })
          .catch(res => {
            if (res.is_ready) {
              res.wx.openLocation(config);
            }
          });
      } else {
        if (!this.mapKey)
          return this.$dialog.error(
            "暂无法使用查看地图，请配置您的腾讯地图key"
          );
        this.mapShow = true;
      }
    },
    goBack() {
      const history = this.app.history,
        last = history[history.length - 1] || {};
      if (last.name === "MyOrder") return this.$router.go(-1);
      else return this.$router.replace({ path: "/order/list/" });
    },
    cancelOrder() {
      cancelOrderHandle(this.orderInfo.order_id)
        .then(() => {
          setTimeout(() => this.goBack(), 300);
        })
        .catch(() => {
          this.getDetail();
        });
    },
    takeOrder() {
      this.$dialog.loading.open("正在加载中");
      takeOrderHandle(this.orderInfo.order_id)
        .then(res => {
          // console.log(res,"res");
          // if (
          //   (res.data.gain_integral != "0.00" &&
          //     res.data.gain_coupon != "0.00") ||
          //   (res.data.gain_integral > 0 && res.data.gain_coupon > 0)
          // ) {
          //   this.$dialog.loading.close();
          //   this.generalActive = true;
          //   this.generalContent = {
          //     promoterNum: `恭喜您获得${res.data.gain_coupon}元优惠券以及${
          //       res.data.gain_integral
          //     }积分，购买商品时可抵现哦～`,
          //     title: "恭喜您获得优惠礼包"
          //   };
          //   return;
          // } else if (
          //   res.data.gain_integral != "0.00" ||
          //   res.data.gain_integral > 0
          // ) {
          //   this.$dialog.loading.close();
          //   this.generalActive = true;
          //   this.generalContent = {
          //     promoterNum: `恭喜您获得${
          //       res.data.gain_integral
          //     }积分，购买商品时可抵现哦～`,
          //     title: "赠送积分"
          //   };
          //   return;
          // } else if (
          //   res.data.gain_coupon != "0.00" ||
          //   res.data.gain_coupon > 0
          // ) {
          //   this.$dialog.loading.close();
          //   this.generalActive = true;
          //   this.generalContent = {
          //     promoterNum: `恭喜您获得${
          //       res.data.gain_coupon
          //     }元优惠券，购买商品时可抵现哦～`,
          //     title: "恭喜您获得优惠券"
          //   };
          //   return;
          // } else {
          this.$dialog.loading.close();
          this.$dialog.success(res.msg);
          // }
          this.getDetail();
        })
        .catch(res => {
          console.log(res);
          this.$dialog.loading.close();
          this.$dialog.error(res.msg);
        });
    },
    delOrder() {
      delOrderHandle(this.orderInfo.order_id).then(() => {
        setTimeout(() => this.goBack(), 300);
      });
    },
    setOfflinePayStatus: function (status) {
      var that = this;
      that.offlinePayStatus = status;
      if (status === 1 && that.orderTypeNameStatus === true) {
        that.payType.push("offline");
      }
    },
    getOrderStatus: function () {
      let orderInfo = this.orderInfo || {},
        _status = orderInfo._status || { _type: 0 },
        status = {};
      let type = parseInt(_status._type),
        delivery_type = orderInfo.delivery_type,
        seckill_id = orderInfo.seckill_id ? parseInt(orderInfo.seckill_id) : 0,
        bargain_id = orderInfo.bargain_id ? parseInt(orderInfo.bargain_id) : 0,
        combination_id = orderInfo.combination_id
          ? parseInt(orderInfo.combination_id)
          : 0;
      status = {
        type: type,
        class_status: 0
      };

      if (this.CompletedType === 4) {
        let itemDate = new Date(orderInfo._pay_time);
        let sixMonthsAgo = new Date();
        sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
        if (itemDate < sixMonthsAgo) {
          this.type4logistics=false
          this.orderInfo._status._msg='交易完成,感谢您的支持'
          status.type = 4
        }else{
          this.type4logistics=true
        }
      }else{
        this.type4logistics=true
      }
      if (type === 1 && combination_id > 0) {
        status.type = 6;
        status.class_status = 1;
      } //查看拼团
      if (type === 2 && delivery_type === "express") status.class_status = 2; //查看物流
      if (type === 2) status.class_status = 3; //确认收货
      if (type === 4 || type === 0) status.class_status = 4; //删除订单
      if (
        !seckill_id &&
        !bargain_id &&
        !combination_id &&
        (type === 3 || type === 4)
      )
        status.class_status = 5; //再次购买
      if (type == 9) {
        //线下付款
        status.class_status = 0;
        this.offlineStatus = false;
      }
      this.status = status;
    },
    getDetail() {
      const id = this.id;
      if (!id) return this.$dialog.error("订单不存在");
      orderDetail(id)
        .then(res => {
          if (res.data.vip_card) {
            res.data.cartInfo && res.data.cartInfo.forEach((item, index) => {
              item.vip_card = [];
              res.data.vip_card && res.data.vip_card.forEach((val, key) => {
                val.forEach((v, i) => {
                  if (item.productInfo.store_info == '爱奇艺') {
                    //爱奇艺
                    if (item.productInfo.attrInfo.suk == '黄金VIP月卡') {
                      if (v.video_type == 0 && v.attribute == 2 && v.type == 1) {
                        v.title = '爱奇艺黄金VIP月卡'
                        item.vip_card.push(v);

                      }
                    } else if (item.productInfo.attrInfo.suk == '黄金VIP季卡') {
                      if (v.video_type == 0 && v.attribute == 3 && v.type == 1) {
                        v.title = '爱奇艺黄金VIP季卡'
                        item.vip_card.push(v);

                      }
                    } else if (item.productInfo.attrInfo.suk == '黄金VIP半年卡') {
                      if (v.video_type == 0 && v.attribute == 4 && v.type == 1) {
                        v.title = '爱奇艺黄金VIP半年卡'
                        item.vip_card.push(v);

                      }
                    } else if (item.productInfo.attrInfo.suk == '黄金VIP年卡') {
                      if (v.video_type == 0 && v.attribute == 5 && v.type == 1) {
                        v.title = '爱奇艺黄金VIP年卡'
                        item.vip_card.push(v);

                      }
                    } else if (item.productInfo.attrInfo.suk == '星钻VIP季卡') {
                      if (v.video_type == 0 && v.attribute == 3 && v.type == 2) {
                        v.title = '爱奇艺星钻VIP季卡'
                        item.vip_card.push(v);

                      }
                    } else if (item.productInfo.attrInfo.suk == '星钻VIP半年卡') {
                      if (v.video_type == 0 && v.attribute == 4 && v.type == 2) {
                        v.title = '爱奇艺星钻VIP半年卡'
                        item.vip_card.push(v);

                      }
                    }
                    //腾讯
                  } else if (item.productInfo.store_info == '腾讯') {
                    if (item.productInfo.attrInfo.suk == 'VIP月卡') {
                      if (v.video_type == 1 && v.attribute == 2 && v.type == 1) {
                        v.title = '腾讯VIP月卡';
                        item.vip_card.push(v);

                      }
                    } else if (item.productInfo.attrInfo.suk == 'VIP季卡') {
                      if (v.video_type == 1 && v.attribute == 3 && v.type == 1) {
                        v.title = '腾讯VIP季卡'
                        item.vip_card.push(v);

                      }
                    } else if (item.productInfo.attrInfo.suk == 'VIP年卡') {
                      if (v.video_type == 1 && v.attribute == 5 && v.type == 1) {
                        v.title = '腾讯VIP年卡'
                        item.vip_card.push(v);

                      }
                    } else if (item.productInfo.attrInfo.suk == '超级VIP季卡') {
                      if (v.video_type == 1 && v.attribute == 3 && v.type == 2) {
                        v.title = '腾讯超级VIP季卡'
                        item.vip_card.push(v);

                      }
                    }
                    // 优酷
                  } else if (item.productInfo.store_info == '优酷') {
                    if (item.productInfo.attrInfo.suk == 'VIP月卡') {
                      if (v.video_type == 3 && v.attribute == 2 && v.type == 1) {
                        v.title = '优酷VIP月卡'

                        item.vip_card.push(v);
                      }
                    } else if (item.productInfo.attrInfo.suk == 'VIP季卡') {
                      if (v.video_type == 3 && v.attribute == 3 && v.type == 1) {
                        v.title = '优酷VIP季卡'

                        item.vip_card.push(v);
                      }
                    } else if (item.productInfo.attrInfo.suk == 'VIP半年卡') {
                      if (v.video_type == 3 && v.attribute == 4 && v.type == 1) {
                        v.title = '优酷VIP半年卡'

                        item.vip_card.push(v);
                      }
                    }
                    // 芒果
                  } else if (item.productInfo.store_info == '芒果') {
                    if (item.productInfo.attrInfo.suk == 'VIP月卡') {
                      if (v.video_type == 2 && v.attribute == 2 && v.type == 1) {
                        v.title = '芒果VIP月卡'

                        item.vip_card.push(v);
                      }
                    } else if (item.productInfo.attrInfo.suk == 'VIP季卡') {
                      if (v.video_type == 2 && v.attribute == 3 && v.type == 1) {
                        v.title = '芒果VIP季卡'

                        item.vip_card.push(v);
                      }
                    } else if (item.productInfo.attrInfo.suk == 'VIP半年卡') {
                      if (v.video_type == 2 && v.attribute == 4 && v.type == 1) {
                        v.title = '芒果VIP半年卡'

                        item.vip_card.push(v);
                      }
                    } else if (item.productInfo.attrInfo.suk == '全屏会员季卡') {
                      if (v.video_type == 2 && v.attribute == 3 && v.type == 2) {
                        v.title = '芒果全屏会员季卡'

                        item.vip_card.push(v);
                      }
                    }
                    //  QQ音乐
                  } else if (item.productInfo.store_info == 'QQ音乐') {
                    if (item.productInfo.attrInfo.suk == 'VIP月卡') {
                      if (v.video_type == 4 && v.attribute == 2 && v.type == 1) {
                        v.title = 'QQ音乐VIP月卡'

                        item.vip_card.push(v);
                      }
                    } else if (item.productInfo.attrInfo.suk == 'VIP季卡') {
                      if (v.video_type == 4 && v.attribute == 3 && v.type == 1) {
                        v.title = 'QQ音乐VIP季卡'

                        item.vip_card.push(v);
                      }
                    } else if (item.productInfo.attrInfo.suk == 'VIP年卡') {
                      if (v.video_type == 4 && v.attribute == 5 && v.type == 1) {
                        v.title = 'QQ音乐VIP年卡'

                        item.vip_card.push(v);
                      }
                    }
                    // 网易云
                  } else if (item.productInfo.store_info == '网易云') {
                    if (item.productInfo.attrInfo.suk == 'VIP月卡') {
                      if (v.video_type == 5 && v.attribute == 2 && v.type == 1) {
                        v.title = '网易云VIP月卡'

                        item.vip_card.push(v);
                      }
                    } else if (item.productInfo.attrInfo.suk == 'VIP季卡') {
                      if (v.video_type == 5 && v.attribute == 3 && v.type == 1) {
                        v.title = '网易云VIP季卡'

                        item.vip_card.push(v);
                      }
                    } else if (item.productInfo.attrInfo.suk == 'VIP年卡') {
                      if (v.video_type == 5 && v.attribute == 5 && v.type == 1) {
                        v.title = '网易云VIP年卡'

                        item.vip_card.push(v);
                      }
                    }
                    // 喜马拉雅
                  } else if (item.productInfo.store_info == '喜马拉雅') {
                    if (item.productInfo.attrInfo.suk == 'VIP月卡') {
                      if (v.video_type == 6 && v.attribute == 2 && v.type == 1) {
                        v.title = '喜马拉雅VIP月卡'

                        item.vip_card.push(v);
                      }
                    } else if (item.productInfo.attrInfo.suk == 'VIP季卡') {
                      if (v.video_type == 6 && v.attribute == 3 && v.type == 1) {
                        v.title = '喜马拉雅VIP季卡'

                        item.vip_card.push(v);
                      }
                    } else if (item.productInfo.attrInfo.suk == 'VIP年卡') {
                      if (v.video_type == 6 && v.attribute == 5 && v.type == 1) {
                        v.title = '喜马拉雅VIP年卡'

                        item.vip_card.push(v);
                      }
                    }
                    // 樊登读书
                  } else if (item.productInfo.store_info == '樊登读书') {
                    if (item.productInfo.attrInfo.suk == 'VIP年卡') {
                      if (v.video_type == 7 && v.attribute == 5 && v.type == 1) {
                        v.title = '樊登读书VIP年卡'

                        item.vip_card.push(v);
                      }
                    }
                    // KEEP
                  } else if (item.productInfo.store_info == 'KEEP') {
                    if (item.productInfo.attrInfo.suk == 'VIP月卡') {
                      if (v.video_type == 8 && v.attribute == 2 && v.type == 1) {
                        v.title = 'KEEPVIP月卡'

                        item.vip_card.push(v);
                      }
                    } else if (item.productInfo.attrInfo.suk == 'VIP季卡') {
                      if (v.video_type == 8 && v.attribute == 3 && v.type == 1) {
                        v.title = 'KEEPVIP季卡'

                        item.vip_card.push(v);
                      }
                    }
                    // 百度网盘
                  } else if (item.productInfo.store_info == '百度网盘') {
                    if (item.productInfo.attrInfo.suk == '普通会员月卡') {
                      if (v.video_type == 9 && v.attribute == 2 && v.type == 1) {
                        v.title = '百度网盘普通会员月卡'

                        item.vip_card.push(v);
                      }
                    }
                  }
                })

              })
            })
          }
          res.data.refund_reason_time=new Date(res.data.refund_reason_time*1000).toLocaleString()
          this.orderInfo = res.data;
          this.payType = [res.data.pay_type];

          this.getOrderStatus();
          if (this.orderInfo.combination_id > 0) {
            this.orderTypeName = "拼团订单";
            this.orderTypeNameStatus = false;
          } else if (this.orderInfo.bargain_id > 0) {
            this.orderTypeName = "砍价订单";
            this.orderTypeNameStatus = false;
          } else if (this.orderInfo.seckill_id > 0) {
            this.orderTypeName = "秒杀订单";
            this.orderTypeNameStatus = false;
          }
          this.system_store = res.data.system_store || {};
          this.mapKey = res.data.mapKey;
          this.setOfflinePayStatus(this.orderInfo.offlinePayStatus);

          this.$nextTick(function () {
            let copybtn = document.getElementsByClassName("copy-data");
            const clipboard = new ClipboardJS(copybtn);
            clipboard.on("success", () => {
              this.$dialog.success("复制成功");
            });
          });

        })
        .catch(err => {
          this.$dialog.error(err.msg);
          this.$router.go(-1);
        });
    },
    async toPay(type) {
      var that = this;
      await payOrderHandle(this.orderInfo.order_id, type, that.from)
        .then(() => { })
        .catch(res => {
          if (res.status === "WECHAT_H5_PAY")
            that.$router.push({
              path: "/order/status/" + that.orderInfo.order_id + "/0"
            });
        });
      that.getDetail();
    }
  }
};
</script>
<style scoped>
.goodCall {
  color: #e93323;
  text-align: center;
  width: 100%;
  height: 0.86rem;
  padding: 0 0.3rem;
  border-bottom: 0.01rem solid #eee;
  font-size: 0.3rem;
  line-height: 0.86rem;
  background: #fff;
}

.iconfont {
  margin-right: 0.15rem;
}

.geoPage {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 10000;
}

.order-details .writeOff {
  background-color: #fff;
  margin-top: 0.13rem;
  padding-bottom: 0.3rem;
}

.order-details .writeOff .title {
  font-size: 0.3rem;
  color: #282828;
  height: 0.87rem;
  border-bottom: 1px solid #f0f0f0;
  padding: 0 0.3rem;
  line-height: 0.87rem;
}

.order-details .writeOff .grayBg {
  background-color: #f2f5f7;
  width: 5.9rem;
  height: 3.84rem;
  border-radius: 0.2rem 0.2rem 0 0;
  margin: 0.5rem auto 0 auto;
  padding-top: 0.55rem;
}

.order-details .writeOff .grayBg .pictrue {
  width: 2.9rem;
  height: 2.9rem;
  margin: 0 auto;
}

.order-details .writeOff .grayBg .pictrue img {
  width: 100%;
  height: 100%;
  display: block;
}

.order-details .writeOff .gear {
  width: 5.9rem;
  height: 0.3rem;
  margin: 0 auto;
}

.order-details .writeOff .gear img {
  width: 100%;
  height: 100%;
  display: block;
}

.order-details .writeOff .num {
  background-color: #f0c34c;
  width: 5.9rem;
  height: 0.84rem;
  color: #282828;
  font-size: 0.48rem;
  margin: 0 auto;
  border-radius: 0 0 0.2rem 0.2rem;
  text-align: center;
  padding-top: 0.04rem;
}

.order-details .writeOff .rules {
  margin: 0.46rem 0.3rem 0 0.3rem;
  border-top: 0.01rem solid #f0f0f0;
  padding-top: 0.1rem;
}

.order-details .writeOff .rules .item {
  margin-top: 0.15rem;
}

.order-details .writeOff .rules .item .rulesTitle {
  font-size: 0.28rem;
  color: #282828;
}

.order-details .writeOff .rules .item .rulesTitle .iconfont {
  font-size: 0.3rem;
  color: #333;
  margin-right: 0.08rem;
  margin-top: 0.05rem;
}

.order-details .writeOff .rules .item .info {
  font-size: 0.28rem;
  color: #999;
  margin-top: 0.05rem;
}

.order-details .writeOff .rules .item .info .time {
  margin-left: 0.2rem;
}

.order-details .map {
  height: 0.86rem;
  font-size: 0.3rem;
  color: #282828;
  line-height: 0.86rem;
  border-bottom: 0.01rem solid #f0f0f0;
  margin-top: 0.13rem;
  background-color: #fff;
  padding: 0 0.3rem;
}

.order-details .map .place {
  font-size: 0.26rem;
  width: 1.76rem;
  height: 0.5rem;
  border-radius: 0.25rem;
  line-height: 0.5rem;
  text-align: center;
}

.order-details .map .place .iconfont {
  font-size: 0.27rem;
  height: 0.27rem;
  line-height: 0.27rem;
  margin: 0.02rem 0.03rem 0 0;
}

.order-details .address .name .iconfont {
  font-size: 0.34rem;
  margin-left: 0.1rem;
}

.title_nav {
  display: flex;
  width: 100%;
  /* background: #fff; */
  height: 0.7rem;
  padding-left: 0.2rem;
  padding-top: 0.15rem;
  background: white;
}

.nav_address {
  width: 80%;
  text-align: center;
  margin-left: 0.4rem;
}

.refundlist {
  width: 90%;
  background: white;
  margin-left: 0.4rem;
  margin-top: 0.3rem;
  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
  padding-bottom: 0.1rem;
  padding-top: 0.1rem;
}

.refundlist2 {
  display: flex;
  justify-content: space-between;
}

.refundlist2 .icon {
  margin-top: 0.58rem;
  margin-right: 0.2rem;
  overflow: none;
}

.quantity {
  padding: 0.3rem;
  font-size: 0.3rem;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #242424;

}

.quantit {
  display: flex;
  margin-left: 0.3rem;
}

.quantit img {
  width: 1.5rem;
  height: 1.5rem;
}

.quantiy {
  width: 100%;
  margin-left: 0.2rem;
  text-align: left;
}

.quantiyText {
  font-family: PingFang SC-Semibold, PingFang SC;
  color: #242424;
  width: 100%;
  font-size: 0.3rem;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-box-pack: center;
  /* -webkit-box-align: center; */
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-align: left;
}

.quan {
  display: flex;
  width: 100% !important;
  justify-content: space-between;
  margin-top: 0.2rem;
}

.tity {
  color: #ee453e !important;
  display: flex !important;
  width: 21% !important;
}

.tity img {
  width: 0.35rem;
  height: 0.35rem;
}

.orderInformation {
  width: 90%;
  height: 3.7rem;
  background: white;
  margin-top: 0.2rem;
  margin-left: 0.4rem;
  border-radius: 0.15rem 0.15rem 0.15rem 0.15rem;
  /* padding-left: 0.3rem; */
}

.orderInformation div {
  padding-bottom: 0.3rem;
}

.orderInformation span {
  color: black;
}

.titleText {
  color: #9F9F9F;
}

.orderInformation img {
  width: 0.2rem;
  height: 0.2rem;
}

.progressText {
  margin: 0.2rem 0.4rem;
  font-size: 0.35rem;
}

.progressTime {
  margin: 0.2rem 0.4rem;
  color: #9f9f9f;
}

::v-deep .van-step__title.van-step__title {
  font-size: 0.3rem !important;
}

.RefundInformation {
  font-size: 0.3rem;
  font-weight: 900;
  padding: 0.2rem 0.4rem;
}

.refundTime {
  font-size: 0.3rem;
  padding: 0.1rem 0.4rem;
}

.Recharge_phone{
  font-size: 0.3rem;
  padding: 0.3rem;
}
.Recharge_phone span{
  color: red;
}
</style>